import { combineReducers } from 'redux';
import settings from './settings';
import dataFields from './dataFields';
export default combineReducers({
    settings,
    dataFields
});